export default {
  name: '结业证书',
  permissionsKey:"JG-JYZS",
  icon: 'el-icon-s-management',
  children: {
    courseList:{
      name: '证书列表',
      permissionsKey:"JG-JYZS-ZSLB",
      path: '/completion_certificates/list',
    },
  }
};
